import React from "react";
import { Link } from "react-router-dom";
import "./scratcher-party.css";
import { isLive } from "./AnnouncementBar";

// Home-page banner for the Scratcher Party launch. Times are UTC: 05:00Z is midnight in Jamaica.
// When the Dual-Screen sets go on sale, change their status below and on their listings together.
export const SCRATCHER_PARTY_BANNER = {
  startsAt: "2026-11-03T05:00:00Z",
  endsAt: "2027-01-01T05:00:00Z",
  slimCabinet: "/game-product-detail/6aea636bad32027c0da86836",
  dualScreen: "/game-product-detail/6ae75989809db8cdb8391134",
};

export default function ScratcherPartyBanner({ banner = SCRATCHER_PARTY_BANNER, now = Date.now() }: { banner?: typeof SCRATCHER_PARTY_BANNER; now?: number }) {
  if (!isLive(banner, now)) return null;
  return (
    <section className="sp-banner" aria-labelledby="scratcher-party-title">
      <div className="hs-wrap sp-grid">
        <div className="sp-copy">
          <p className="sp-eyebrow"><span className="sp-new">New</span> Gaming machines</p>
          <h2 id="scratcher-party-title">Scratcher <span>Party</span></h2>
          <p className="sp-lead">
            12 scratch-card style games on one touchscreen, in a slim cabinet with LED trims.
            Ask about purchase or leasing.
          </p>
          <ul className="sp-status">
            <li><span className="sp-pill sp-now">Available now</span> Slim cabinet</li>
            <li><span className="sp-pill sp-soon">Coming soon</span> Dual-Screen linked sets</li>
          </ul>
          <div className="sp-actions">
            <Link className="sp-primary" to={banner.slimCabinet}>See the slim cabinet →</Link>
            <Link className="sp-secondary" to={banner.dualScreen}>Dual-Screen details ↗</Link>
          </div>
          <p className="sp-note">For licensed venues and operators.</p>
        </div>
        <div className="sp-art">
          <img className="sp-slim" src="/promotions/scratcher-party-slim.webp" width={365} height={720} alt="Scratcher Party slim cabinet" />
          <img className="sp-dual" src="/promotions/scratcher-party-master.webp" width={276} height={720} alt="Scratcher Party Dual-Screen machine" />
        </div>
      </div>
    </section>
  );
}
